import { render } from "./NewParametersCard.vue?vue&type=template&id=01e6446a&scoped=true"
import script from "./NewParametersCard.vue?vue&type=script&lang=js"
export * from "./NewParametersCard.vue?vue&type=script&lang=js"

import "./NewParametersCard.vue?vue&type=style&index=0&id=01e6446a&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e6446a"]])

export default __exports__